<div class="page-innder-body portlet light ">
  <div class="portlet-body">
    <!-- Skeleton Loader -->
    @if (artistsLoading) {
      <div class="skeleton-loader">
        <div class="d-flex justify-content-between align-items-center py-3" style="border-bottom: 1px solid #e9ecef;">
          <div class="skeleton" style="width: 160px; height: 28px;"></div>
          <div class="d-flex gap-2">
            <div class="skeleton" style="width: 110px; height: 36px; border-radius: 6px;"></div>
            <div class="skeleton" style="width: 40px; height: 36px; border-radius: 6px;"></div>
          </div>
        </div>
        <div class="d-flex gap-4 my-3 flex-wrap">
          @for (i of [1,2,3,4]; track i) {
            <div class="skeleton" style="width: 220px; height: 28px; border-radius: 20px;"></div>
          }
        </div>
        <div class="skeleton" style="width: 100%; height: 40px; border-radius: 6px; margin-bottom: 12px;"></div>
        <div class="d-flex py-2" style="border-bottom: 1px solid #e9ecef; gap: 16px;">
          @for (i of [1,2,3,4,5,6,7]; track i) {
            <div class="skeleton" style="width: 14%; height: 18px;"></div>
          }
        </div>
        @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
          <div class="d-flex py-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
            @for (j of [1,2,3,4,5,6,7]; track j) {
              <div class="skeleton" style="width: 14%; height: 16px;"></div>
            }
          </div>
        }
      </div>
    }

    @if (!artistsLoading) {
      <div class="table-toolbar">
        <div class="row">
          <div class="col-md-12">
            <p-toolbar>
              <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'artists.viewArtists' | transloco }}</div>
              <div class="p-toolbar-group-end">
                <p-button type="button" icon="fa fa-plus" [label]="'artists.addNew' | transloco" [outlined]="true"
                (click)="showDialog()"></p-button>
                <p-button type="button" icon="fa fa-refresh" class="ms-2 " [outlined]="true"></p-button>
              </div>
            </p-toolbar>
          </div>
        </div>
      </div>
      <div class="row my-2 p-1">
        <div class="col d-flex justify-content-start p-2">
          <div class="d-flex justify-content-end align-items-center flex-wrap">
            <div class="d-flex flex-column align-items-start me-3">
              <div class="d-flex align-items-center">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterByArtflow" (onChange)="getFilteredArtist()"></p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'artists.filterByArtflowProAdmin' | transloco }}</span>
              </div>
            </div>
            <div class="d-flex flex-column align-items-start me-3">
              <div class="d-flex align-items-center">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterByFreeTrial" (onChange)="getFilteredArtist()"></p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'artists.filterFreeTrialArtists' | transloco }}</span>
              </div>
            </div>
            <div class="d-flex flex-column align-items-start me-3">
              <div class="d-flex align-items-center">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterByStripe" (onChange)="getFilteredArtist()"></p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'artists.filterByStripeSubscription' | transloco }}</span>
              </div>
            </div>
            <div class="d-flex flex-column align-items-start ms-2">
              <div class="d-flex align-items-center">
                <p-inputSwitch class="mt-1" [(ngModel)]="filterByAppleInAppPurchase" (onChange)="getFilteredArtist()"></p-inputSwitch>
                <span class="ms-2 fw-semibold">{{ 'artists.filterInAppAppleSubscription' | transloco }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive mt-3">
        <p-table #dt [value]="artists" dataKey="ArtistId" [rowHover]="true"
          styleClass="p-datatable-gridlines p-datatable-striped" [loading]="artistsLoading"
          [globalFilterFields]="['Name', 'Email', 'PhoneNumber']" selectionMode="single" [paginator]="artists.length >15"
          [rows]="15" [reorderableColumns]="true" [paginator]="artists.length > recordCount" [rows]="recordCount"
          [reorderableColumns]="true" [resizableColumns]="false">
          <!-- Table Caption Template -->
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="row">
                <div class="col-md-8 text-right">
                  <!-- Search Box -->
                  <div
                    class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                    <button type="button"
                      class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                      <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                    </button>
                    <input type="text"
                      class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                      (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'artists.search' | transloco" />
                    </div>
                  </div>
                  <div class="col-md-4 text-left">
                    <!-- Dropdown for Record Count -->
                    <p-dropdown [(ngModel)]="recordCount" (onChange)="updateRecordCount(recordCount)"
                      [options]="recordOptions" [placeholder]="'artists.selectNumberOfRecords' | transloco" [appendTo]="'body'">
                    </p-dropdown>
                  </div>
                </div>
              </div>
            </ng-template>
            <!-- Table Header Template -->
            <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
              <tr>
                <th [pSortableColumn]="'Name'">{{ 'artists.artistName' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                <th [pSortableColumn]="'Email'">{{ 'artists.email' | transloco }} <p-sortIcon [field]="'Email'"></p-sortIcon></th>
                <th [pSortableColumn]="'PhoneNumber'">{{ 'artists.phoneNumber' | transloco }} <p-sortIcon [field]="'PhoneNumber'"></p-sortIcon></th>
                <th [pSortableColumn]="'ItemsSoldThisYear'">{{ 'artists.itemsSold' | transloco }} <p-sortIcon
                [field]="'ItemsSoldThisYear'"></p-sortIcon></th>
                <th [pSortableColumn]="'BusinessName'">{{ 'artists.business' | transloco }} <p-sortIcon [field]="'BusinessName'"></p-sortIcon></th>
                <!-- <th>Account type</th> -->
                <th [pSortableColumn]="'CreatedDate'">{{ 'artists.created' | transloco }} <p-sortIcon [field]="'CreatedDate'"></p-sortIcon></th>
                <th>{{ 'artists.actions' | transloco }}</th>
              </tr>
            </ng-template>
            <!-- Table Body Template -->
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
              <tr>
                <td>
                  <div class="d-flex form-group align-items-center">
                    <img [src]="rowData.ImgUrl ? rowData.ImgUrl : 'assets/images/No-Image.png'" class="rounded-circle me-1"
                      style="width: 25px; height: 25px; object-fit: cover;" />
                      <div class="d-flex align-items-center">
                        <div class="text-capitalize me-1">{{ rowData.Name }}</div>
                        @if (rowData.IsPro) {
                          <!-- Dynamic background color for Pro badge -->
                          @if (rowData.IsPro) {
                            <span class="badge"
                              [ngStyle]="{'background-color': '#178d9b', 'color': 'white'}">
                              {{ 'artists.pro' | transloco }}
                            </span>
                          }
                        }
                        <!-- <span *ngIf="!rowData.IsProByPlatform" class="badge bg-secondary">Free Account</span> -->
                      </div>
                    </div>
                  </td>
                  <td>{{rowData.Email}}</td>
                  <td>{{rowData.PhoneNumber}}</td>
                  <td>{{rowData.ItemsSoldThisYear}}</td>
                  <td>
                    {{rowData.BusinessName}}
                    <div class="text-muted small">{{rowData.BusinessNumber}}</div>
                  </td>
                  <td>{{rowData.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>
                    <div [ngClass]="{'justify-content-end': true}" class="d-flex align-items-center">
                      <!-- Show "up" button for users who are not Pro -->
                      @if (!rowData.IsPro) {
                        <button pButton class="p-button-sm"
                          [style.backgroundColor]="'#ffffff'" [style.color]="'#f79421'" [style.borderColor]="'#f79421'"
                          icon="pi pi-shield" [label]="'artists.upgrade' | transloco"
                          [pTooltip]="'artists.upgradeToProAccount' | transloco" tooltipPosition="top" (click)="switchToProAccount(rowData.Id,true)">
                        </button>
                      }
                      @if (rowData.IsPro && rowData.ProBySource === proBySource.Artflow) {
                        <button pButton class="p-button-sm"
                          [style.backgroundColor]="'#ffffff'" [style.color]="'#178d9b'" [style.borderColor]="'#178d9b'"
                          [label]="'artists.downgrade' | transloco" icon="pi pi-chevron-left"
                          [pTooltip]="'artists.downgradeToFreeAccount' | transloco" tooltipPosition="top" (click)="switchToProAccount(rowData.Id,false)">
                        </button>
                      }
                      <!-- Edit Button -->
                      <div class="justify-content-end d-flex">
                        <button pButton (click)="editArtist(rowData.Id)" class="p-button p-button-sm ms-2 p-button-outlined"
                          icon="pi pi-pencil" size="small" [pTooltip]="'artists.editArtist' | transloco" tooltipPosition="top">
                        </button>
                        <!-- Delete Button -->
                        <button pButton (click)="deleteArtist(rowData.Id)"
                          class="p-button-danger p-button-sm ms-2 p-button-outlined" icon="pi pi-trash" size="small"
                          [pTooltip]="'artists.deleteArtist' | transloco" tooltipPosition="top">
                        </button>
                        <button pButton (click)="moveToArtistProduct(rowData.Id)" class="p-button-sm ms-2 p-button-outlined"
                          icon="pi pi-eye" size="small" [pTooltip]="'artists.viewArtistProducts' | transloco" tooltipPosition="top">
                        </button>
                        <!-- Switch Account Button -->
                        <button pButton icon="fa fa-sign-in" class="p-button-sm ms-2 p-button-outlined"
                          (click)="switchAccount(rowData)" [pTooltip]="'artists.switchAccount' | transloco" tooltipPosition="top">
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <!-- Empty Message Template -->
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="7">
                    <div class="text-center">{{ 'artists.noRecordsFound' | transloco }}</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    </div>
    <!-- popop -->
    <p-dialog [header]="isEditMode ? ('artists.editArtistDialog' | transloco) : ('artists.addArtist' | transloco)" [(visible)]="artistDialogvisible" [modal]="true"
      [style]="{ 'width': '630px' }" (onHide)="closeDialog()">
      <div class="p-fluid p-2">
        <form class="form-horizontal" #artistForm="ngForm">
          <p-tabView [(activeIndex)]="selectedTabIndex">
            <!-- Tab Content for "User Information" -->
            <p-tabPanel [header]="'artists.personalInformation' | transloco">
              <!-- Artist Image Section -->
              <div class="form-group mt-2 text-center">
                @if (!formData.ImgUrl) {
                  <div class="input-group justify-content-center">
                    <!-- <p-fileUpload #fileUpload name="LogoFile" (onSelect)="onFileSelected($event.files, 'ArtistImg')"
                  chooseLabel="Profile-Image" [auto]="true" mode="basic"></p-fileUpload> -->
                  <p-fileUpload #fileUpload name="productImageFile" accept="image/*"
                    (onSelect)="onFileSelected($event.files, 'ArtistImg')" [chooseLabel]="'artists.select' | transloco" [auto]="true"
                    [previewWidth]="70" styleClass="upload_image" [multiple]="false" mode="basic">
                    <!-- <ng-template pTemplate="toolbar">
                    <div class="mt-2">Drag and drop file here</div>
                  </ng-template> -->
                </p-fileUpload>
              </div>
            }

            @if (formData.ImgUrl) {
              <div class="position-relative d-inline-block mt-3">
                <!-- Display uploaded image with rounded corners and shadow -->
                <img [src]="formData.ImgUrl" class="rounded-circle img-thumbnail"
                  style="width: 100px; height: 100px; object-fit: cover; border: 2px solid #fff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);" />
                  <div class="position-absolute top-0 end-0 m-2">
                    <button type="button" class="btn btn-sm btn-danger p-button-outlined"
                      (click)="removeImg('ArtistImg')">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              }
            </div>


            <!-- Artist Name -->
            <div class="row">
              <div class="col-6">
                <div class="form-group mt-3">
                  <label for="FirstName"><span class="text-danger me-1">*</span>{{ 'artists.artistFirstName' | transloco }}</label>
                  <input type="text" id="FirstName" pInputText [placeholder]="'artists.artistFirstName' | transloco"
                    class="form-control form-control-sm" [(ngModel)]="formData.FirstName" name="FirstName" required />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group mt-3">
                    <label for="LastName">{{ 'artists.artistLastName' | transloco }}</label>
                    <input type="text" id="LastName" pInputText [placeholder]="'artists.artistLastName' | transloco"
                      class="form-control form-control-sm" [(ngModel)]="formData.LastName" name="LastName" required />
                    </div>
                  </div>
                </div>
                <!-- <div class="form-group mt-3">
                <label for="fullName"><span class="text-danger me-1">*</span>Artist Name</label>
                <input type="text" id="fullName" pInputText placeholder="Artist Name" class="form-control form-control-sm"
                  [(ngModel)]="formData.Name" name="fullName" required />
                </div> -->

                <!-- Art Type -->
                <div class="form-group mt-2">
                  <label for="artType" class="form-label">{{ 'artists.artTypes' | transloco }}</label>
                  <p-multiSelect [options]="artTypes" [name]="'artType'" [placeholder]="'artists.selectArtTypes' | transloco" optionLabel="label"
                    [(ngModel)]="selectedArtTypes" (onChange)="onArtTypesChange($event)" [style]="{ 'width': '100%' }"
                  [maxSelectedLabels]="6"></p-multiSelect>
                </div>

                <div class="form-group mt-2">
                  <label for="artType" class="form-label">{{ 'artists.changeRuleset' | transloco }}</label>
                  <p-dropdown [options]="subscriptionRules" [(ngModel)]="formData.SubscriptionRuleSetId"
                  [placeholder]="'artists.selectRuleset' | transloco" name="subscriptionRules" [style]="{'width':'100%'}"></p-dropdown>
                  <div class="text-secondary">{{ 'artists.rulesetWarning' | transloco }}</div>
                </div>

                <!-- Email -->
                <div class="form-group mt-2">
                  <label for="email" class="form-label"><span class="text-danger me-1">*</span>{{ 'artists.email' | transloco }}</label>
                  <input id="email" type="email" pInputText [placeholder]="'artists.email' | transloco" class="form-control form-control-sm"
                    [(ngModel)]="formData.Email" name="email" required />
                  </div>

                  <!-- Phone Number -->
                  <div class="form-group mt-2">
                    <label for="phoneNumber" class="form-label">{{ 'artists.phoneNumber' | transloco }}</label>
                    <input id="phoneNumber" type="tel" pInputText [placeholder]="'artists.phoneNumber' | transloco"
                      class="form-control form-control-sm" [(ngModel)]="formData.PhoneNumber" name="phoneNumber"  />
                    </div>

                    <!-- Mobile Number -->
                    <div class="form-group mt-2">
                      <label for="MobileNumber" class="form-label">{{ 'artists.mobileNumber' | transloco }}</label>
                      <input id="MobileNumber" type="text" pInputText [placeholder]="'artists.mobileNumber' | transloco"
                        class="form-control form-control-sm" [(ngModel)]="formData.MobileNumber" name="MobileNumber"  />
                      </div>
                      <!-- ABN: Australian Business Number -->
                      <div class="form-group mt-2">
                        <label class="form-label" for="ABN">{{ 'artists.abn' | transloco }}</label>
                        <input id="Suburb" pInputText [placeholder]="'artists.abn' | transloco" class="form-control form-control-sm"
                          [(ngModel)]="formData.ABN" name="ABN"  />
                        </div>
                        <!-- Facebook Link -->
                        <div class="form-group mt-2">
                          <label class="form-label" for="FacebookLink">{{ 'artists.facebookLink' | transloco }}</label>
                          <input id="FacebookLink" pInputText [placeholder]="'artists.facebookLink' | transloco" class="form-control form-control-sm"
                            [(ngModel)]="formData.FacebookLink" name="FacebookLink"  />
                          </div>
                          <!-- Instagram Link -->
                          <div class="form-group mt-2">
                            <label class="form-label" for="InstagramLink">{{ 'artists.instagramLink' | transloco }}</label>
                            <input id="InstagramLink" pInputText [placeholder]="'artists.instagramLink' | transloco" class="form-control form-control-sm"
                              [(ngModel)]="formData.InstagramLink" name="InstagramLink"/>
                            </div>
                            <!-- Linkedin Link -->
                            <div class="form-group mt-2">
                              <label class="form-label" for="LinkedinLink">{{ 'artists.linkedinLink' | transloco }}</label>
                              <input id="LinkedinLink" pInputText [placeholder]="'artists.linkedinLink' | transloco" class="form-control form-control-sm"
                                [(ngModel)]="formData.LinkedinLink" name="LinkedinLink"  />
                              </div>
                            </p-tabPanel>

                            <!-- Tab Content for "Bank Information" -->
                            <p-tabPanel [header]="'artists.bank' | transloco">
                              <div class="form-group mt-2">
                                <label for="bankName" class="form-label">{{ 'artists.bankName' | transloco }}</label>
                                <input type="text" id="bankName" pInputText [placeholder]="'artists.bankName' | transloco" class="form-control form-control-sm"
                                  [(ngModel)]="formData.BankName" name="bankName"  />
                                </div>
                                <div class="form-group mt-2">
                                  <label for="accountNumber" class="form-label">{{ 'artists.bankAccountNumber' | transloco }}</label>
                                  <input type="text" id="accountNumber" pInputText [placeholder]="'artists.accountNumber' | transloco"
                                    class="form-control form-control-sm" [(ngModel)]="formData.AccountNumber" name="accountNumber"  />
                                  </div>
                                  <div class="form-group mt-2">
                                    <label class="form-label" for="bankAddress">{{ 'artists.bankAddress' | transloco }}</label>
                                    <input type="text" id="bankAddress" pInputText [placeholder]="'artists.bankAddress' | transloco"
                                      class="form-control form-control-sm" [(ngModel)]="formData.BankAddress" name="bankAddress" />
                                    </div>
                                    <div class="form-group p-field mt-2">
                                      <label class="form-label" for="bankBSB">{{ 'artists.bankBSB' | transloco }}</label>
                                      <input type="text" id="bankBSB" pInputText [placeholder]="'artists.bankBSB' | transloco" class="form-control form-control-sm"
                                        [(ngModel)]="formData.BankBSB" name="bankBSB" />
                                      </div>
                                    </p-tabPanel>

                                    <!-- Tab Content for "Address Information" -->
                                    <p-tabPanel [header]="'artists.address' | transloco">
                                      <!-- Address Line 1-->
                                      <div class="form-group p-field mt-2">
                                        <label class="form-label" for="addressLine1">{{ 'artists.addressLine1' | transloco }}</label>
                                        <input type="text" id="addressLine1" pInputText [placeholder]="'artists.addressLine1' | transloco"
                                          class="form-control form-control-sm" [(ngModel)]="formData.AddressLine1" name="addressLine1" />
                                        </div>

                                        <!-- Address Address Line 2 -->
                                        <div class="form-group p-field mt-2">
                                          <label class="form-label" for="addressLine2">{{ 'artists.addressLine2' | transloco }}</label>
                                          <input type="text" id="addressLine2" pInputText [placeholder]="'artists.addressLine2' | transloco"
                                            class="form-control form-control-sm" [(ngModel)]="formData.AddressLine2" name="addressLine2" />
                                          </div>

                                          <div class="form-group p-field mt-2">
                                            <label class="form-label" for="StreetAddress">{{ 'artists.streetAddress' | transloco }}</label>
                                            <input type="text" id="StreetAddress" pInputText [placeholder]="'artists.streetAddress' | transloco"
                                              class="form-control form-control-sm" [(ngModel)]="formData.StreetAddress" name="StreetAddress" />
                                            </div>

                                            <div class="form-group p-field mt-2">
                                              <label class="form-label" for="Suburb">{{ 'artists.suburb' | transloco }}</label>
                                              <input id="Suburb" pInputText [placeholder]="'artists.suburb' | transloco" class="form-control form-control-sm"
                                                [(ngModel)]="formData.Suburb" name="Suburb"  />
                                              </div>


                                              <!-- Address State -->
                                              <div class="form-group p-field mt-2">
                                                <label class="form-label" for="State">{{ 'artists.state' | transloco }}</label>
                                                <input type="text" id="State" pInputText [placeholder]="'artists.state' | transloco" class="form-control form-control-sm"
                                                  [(ngModel)]="formData.State" name="State" />
                                                </div>

                                                <div class="form-group p-field mt-2">
                                                  <label class="form-label" for="PostCode">{{ 'artists.postCode' | transloco }}</label>
                                                  <input type="text" id="PostCode" pInputText [placeholder]="'artists.postCode' | transloco" class="form-control form-control-sm"
                                                    [(ngModel)]="formData.PostCode" name="PostCode" />
                                                  </div>
                                                </p-tabPanel>

                                                <p-tabPanel [header]="'artists.businessTab' | transloco">
                                                  <!-- Business Logo -->
                                                  <div class="form-group mt-3">
                                                    @if (!formData.BusinessLogoUrl) {
                                                      <div class="input-group justify-content-center">
                                                        <p-fileUpload #buissnesslogo name="LogoFile" (onSelect)="onFileSelected($event.files, 'BusinessLogo')"
                                                        [chooseLabel]="'artists.businessLogo' | transloco" [auto]="true" mode="basic"></p-fileUpload>
                                                      </div>
                                                    }


                                                    @if (formData.BusinessLogoUrl) {
                                                      <div class="position-relative text-center mt-2">
                                                        <!-- Display uploaded image with rounded corners and shadow -->
                                                        <div style="position: relative; display: inline-block;">
                                                          <img [src]="formData.BusinessLogoUrl"
                                                            style="width: 80px; height: 80px; object-fit: cover; border-radius: 50%; border: 5px solid #fff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);"
                                                            class="mx-auto d-block" />
                                                            <button type="button"
                                                              class="btn btn-sm btn-danger p-button-outlined position-absolute top-0 end-0 m-2"
                                                              style="z-index: 1;" (click)="removeImg('BusinessLogo')">
                                                              <i class="fa fa-times"></i>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>

                                                    <!-- Business Name -->
                                                    <div class="form-group mt-3">
                                                      <label for="BusinessName" class="form-label">{{ 'artists.businessName' | transloco }}</label>
                                                      <input type="text" id="BusinessName" pInputText [placeholder]="'artists.businessName' | transloco"
                                                        class="form-control form-control-sm" [(ngModel)]="formData.BusinessName" name="BusinessName"  />
                                                      </div>
                                                      <!-- Business Number -->
                                                      <div class="form-group mt-2">
                                                        <label for="BusinessNumber" class="form-label">{{ 'artists.businessNumber' | transloco }}</label>
                                                        <input type="text" id="BusinessNumber" pInputText [placeholder]="'artists.businessNumber' | transloco"
                                                          class="form-control form-control-sm" [(ngModel)]="formData.BusinessNumber" name="BusinessNumber" />
                                                        </div>
                                                        <!-- Business Facebook Link -->
                                                        <div class="form-group mt-2">
                                                          <label class="form-label" for="BusinessFacebookLink">{{ 'artists.businessFacebookLink' | transloco }}</label>
                                                          <input id="BusinessFacebookLink" pInputText [placeholder]="'artists.businessFacebookLink' | transloco"
                                                            class="form-control form-control-sm" [(ngModel)]="formData.BusinessFacebookLink"
                                                            name="BusinessFacebookLink"  />
                                                          </div>
                                                          <!-- Business Linkedin Link -->
                                                          <div class="form-group mt-2">
                                                            <label class="form-label" for="BusinessInstagramLink">{{ 'artists.businessInstagramLink' | transloco }}</label>
                                                            <input id="BusinessInstagramLink" pInputText [placeholder]="'artists.businessInstagramLink' | transloco"
                                                              class="form-control form-control-sm" [(ngModel)]="formData.BusinessInstagramLink"
                                                              name="BusinessInstagramLink"  />
                                                            </div>
                                                            <!-- Linkedin Link -->
                                                            <div class="form-group mt-2">
                                                              <label class="form-label" for="BusinessLinkedinLink">{{ 'artists.businessLinkedInLink' | transloco }}</label>
                                                              <input id="BusinessLinkedinLink" pInputText [placeholder]="'artists.businessLinkedInLink' | transloco"
                                                                class="form-control form-control-sm" [(ngModel)]="formData.BusinessLinkedinLink"
                                                                name="BusinessLinkedinLink"  />
                                                              </div>
                                                            </p-tabPanel>

                                                          </p-tabView>
                                                          <div class="mb-2 mt-2 ">
                                                            <button pButton type="button" class="mt-3 mb-2 " (click)="submitForm()" [label]="'artists.saveChanges' | transloco" class="p-button-outlined"
                                                            [disabled]="!formData.FirstName || !formData.Email"></button>
                                                          </div>
                                                        </form>

                                                        <!-- IMAGE CROPPER COMPONENT SELECTER -->
                                                        @if (showCropperDialog) {
                                                          <app-image-cropper [image]="currentSelectedImageToCrop" [showCropperDialog]="showCropperDialog"
                                                            (onImageCropped)="onImageCropped($event)" (onImageCropperClose)="onImageCropperClose($event)">
                                                          </app-image-cropper>
                                                        }